<template>
    <div id="floatPanel" v-show="type">
        <div class="pane">
            <div class="panel-heading" v-on:click="toggleDialog">
                <h1><i class="icon icon-lg" :class="icon"></i> {{ heading }}</h1>
                <i class="corner-icon" :class="{ 'icon-min': expanded, 'icon-max': !expanded }"></i>
                <i class="corner-icon icon-cross" v-on:click="closeDialog"></i>
            </div>
            <transition name="slide-toggle">
                <div class="panel-body" v-show="expanded">
                    <component v-bind:is="type" :data="info" :name="name"></component>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            dialog: {
                default: {
                    name: '',
                    type: '',
                    info: false
                }
            },
        },
        data() {
            return {
                name: false,
                type: false,
                info: false,
                icon: 'icon-create-circle',
                heading: false,
                expanded: false,
            }
        },
        created() {
            this.name = this.dialog.name;
            this.type = this.dialog.type;
            this.info = this.dialog.info;
            this.setDialog(this.type, this.info);
            this.$eventHub.$on('toggleDialog' + this.name, this.toggleDialog);
            this.$eventHub.$on('closeDialog' + this.name, this.closeDialog);
//            this.$eventHub.$on('setDialog' + this.name, this.setDialog);
            this.$eventHub.$on('updateDialogHeading' + this.name, this.updateDialogHeading);
        },
        methods: {
            updateDialogHeading(data){
                if (typeof data['heading'] !== 'undefined') {
                    this.heading = data.heading;
                }
                if (typeof data['icon'] !== 'undefined') {
                    this.icon = data.icon;
                }
            },
            closeDialog() {
                this.expanded = false;
                this.type = false;
                this.$eventHub.$emit('removeDialog', this.name);
            },
            setDialog(type, data){
                this.expanded = true;
                this.type = type;
                this.heading = 'Add ' + type.ucfirst();
                if (type === 'emailaccount') {
                    this.heading = 'Add Email Account';
                }
                if (type === 'awswebsite') {
                    this.heading = 'Add a AWS Website';
                }
                if (type === 'website') {
                    this.heading = 'Add Hosted Website';
                }
                if (type === 'remote') {
                    this.heading = 'Add WP Remote Website';
                }
                if (type === 'htmlblock') {
                    this.heading = 'Add Content Block';
                }
            },
            toggleDialog() {
                this.expanded = !this.expanded;
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('toggleDialog' + this.name, this.toggleDialog);
            this.$eventHub.$off('closeDialog' + this.name, this.closeDialog);
            this.$eventHub.$off('setDialog' + this.name, this.setDialog);
            this.$eventHub.$off('updateDialogHeading' + this.name, this.updateDialogHeading);
        },
        components: {
            'api':          require('./api/api-create.vue').default,
            'links':          require('./links/links-create.vue').default,
            'fresh':          require('./freshdesk/ticket-create.vue').default,
            'website':          require('./website/website-create.vue').default,
            'awswebsite':          require('./website/aws-create.vue').default,
            'invoice':          require('./invoice/invoice-create.vue').default,
            'htmlblock':          require('./proposal/html-create.vue').default,
            'contact':          require('./contact/contact-create.vue').default,
            'company':          require('./company/company-create.vue').default,
            'domain':           require('./domain/domain-form.vue').default,
            'email':            require('./email/email-create.vue').default,
            'remote':           require('./website/remote-create.vue').default,
            'tax':            require('./tax/tax-form.vue').default,
            'emailaccount':     require('./email/emailaccount-create.vue').default,
            'payment':          require('./payment/payment-form.vue').default,
            'payments':          require('./payment/payment-form.vue').default,
            'emailtemplates':   require('./email/template/email-template-form.vue').default,
            'product':         require('./product/product-form.vue').default,
            'server':         require('./server-form.vue').default,
            'users':            require('./users/user-create.vue').default,
            'paymentGateways':  require('./gateway/payment-gateway-form.vue').default,
            'autoresponder':    require('../components/autoresponder.vue').default
        }
    }
</script>
<style lang="less">
    html.noscroll {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }

    body.noscroll {
        height: 100%;
        padding: 0;
        overflow: auto;
        margin: 0;
        -webkit-overflow-scrolling: touch;
    }
    .slide-toggle-enter-active,
    .slide-toggle-leave-active {
        transition: height 0.5s;
    }
    .slide-toggle-enter-active {
        height: 100%;
    }
    .slide-toggle-enter,
    .slide-toggle-leave-active {
        height: 0;
    }
    .slide-toggle-leave {
        height: 100%;
    }

    .dialogBtn {
        display: block;
        min-height: 48px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        text-transform: uppercase;
        overflow: hidden;
        background: #202226;
        color: #9b9b9b;
        font-size: 0.8em;
        text-align: center;
        position: absolute;
        bottom: 16px;
        left: 0;
        width: 75px;
        letter-spacing: 0.09em;
    }
    #floating-dialogs {
        position: absolute;
        bottom: 0;
        left: 82px;
        z-index:10;
        max-width: 80%;
        @media (max-width: 500px) {
            /*width: 75%;*/
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            bottom:0;
            right:0;
            position: absolute;
            z-index: 1000;
            background: #333;
        }
    }
    #floatPanel {
        display: inline-block;
        width: 650px;
        /*width: 35%;*/
        background-color: #484d5b;
        /*box-shadow: 0 0 10px rgba(0,0,0,0.8);*/
        color: #fff;
        max-height: 80vh;
        /*min-height: 400px;*/
        overflow-y: scroll;
        overflow-x: hidden;
        @media (max-width: 730px) {
            width: 100%;
        }
        @media (max-width: 500px) {
            max-height: none;
            height: 100%;
        }
        .pane {
            position: relative;
            width: 100%;
        }
        .panel-heading {
            /*position: fixed;*/
            background-color: #3e414e;
            width: 644px;
            /*width: 35%;*/
            z-index: 99;
            padding: 4px 15px;
            cursor: pointer;
            position: fixed;
            margin-top: -44px;
            border-radius: 0px;
            @media (max-width: 730px) {
                width: 80%;
            }
            @media (max-width: 500px) {
                /*width: 75%;*/
                margin-top: 0;
                width: inherit;
                top: 0;
                position: fixed;
            }
            .corner-icon {
                position: absolute;
                top: 0;
                padding: 13px;
                background-color: transparent;
                cursor: pointer;
                font-size: 12px;
                &:hover {
                    color: #bdc5d3;
                 }
                &.icon-min {
                    right: 30px;
                 }
                 &.icon-cross {
                    right: 0;
                  }
            }
            h1 {
                color: #3ed8b5;
                font-size: 15px;
                margin-top: 10px;
                .icon {
                    font-size: 15px;
                    margin-top: -4px;
                    margin-right: 3px;
                }
            }
        }
        .panel-body {
            -webkit-transition: all 100ms ease-in-out;
            -moz-transition: all 100ms ease-in-out;
            -ms-transition: all 100ms ease-in-out;
            -o-transition: all 100ms ease-in-out;
            transition: all 100ms ease-in-out;
            @media (max-width: 500px) {
                margin-top: 35px;
                overflow: visible;
            }
            .btn-create {
                background: #3dcaa1;
                border-color: #3dcaa1;
                border-radius: 0px;
                &:hover {
                    color: #fff;
                    background: #3fc197;
                    border-color: #3fc197;
                 }
            }
            .form-group {
                span {
                    color: #FD4F58;
                    font-size: 12px;
                    &.input-group-addon {
                         color: #fff;
                         font-size: 14px;
                     }
                    &.popup-alert {
                        padding: 3px 0px;
                        font-size: 12px;
                        &.success {
                             color: #46C37B!important;
                         }
                        &.error {
                            color: #FD4F58!important;
                        }
                        i {
                               float: none;
                               position: relative;
                               top: 2px;
                               right: 0px;
                               opacity: 1;
                           }
                        }
                }
            }

            .auto-list {
                border-bottom: 0px;
                &.form-control {
                    span {
                        color: #333;
                    }
                }
            }

            .control-label {
                color: #bfc9d0;
                font-weight: 500;
                display: block;
            }
            .form-control {
                background: transparent;
                border-color: #71747d;
                color: #fff;
                height: auto;
                min-height: 34px;
                &:active,
                &:focus {
                     border-color: #fff;
                 }
                 &.tt-input {
                    /*border-bottom: 0px;*/
                  }
            }
            textarea {
                border-color: #787b85;
                background: transparent;
                width: 100%;
            }
            option {
                color: #555;
                background: #fff;
            }
            .form-heading {
                display: none;
            }
            .clickable {
                margin-top: 10px;
                text-align: center;
                width: 14%;
                transition: all ease 0.2s;
                &:hover,
                &.active {
                    color: #3dcaa1;
                 }
                .icon {
                    font-size: 20px;
                }
            }

            .bootstrap-tagsinput {
                background: transparent;
                color: #fff;
                border-color: transparent;
                box-shadow: none;
                font-size: 12px;
                margin-bottom: 15px;
                .tag {
                    border-color: #fff;
                    background: transparent;
                    color: #fff;
                    letter-spacing: 0.04em;
                }
                .list-group {
                    margin-top: 5px;
                    position: absolute;
                    min-width: 100px;
                        li {
                            background: #383e47;
                            border-color: #383e47;
                            padding: 3px 8px;
                            z-index: 99;
                            font-size: 10.5px;
                            color: #fff;
                            cursor: pointer;
                            transition: all ease-in-out 0.2s;
                                &:hover,
                                &:active,
                                &.active,
                                &:focus {
                                     background: #2b313a;
                                     border-color:#2b313a;
                                 }
                        }
                }
                input::placeholder {
                    color: #c3c3c3;
                }
            }
            /*end bootstrap */

            .instruct-sm {
                font-size: 11px;
                color: #979ea5;
                letter-spacing: 0.01em;
                margin-top: -5px;
            }
            .input-group-addon {
                color: #fff;
                padding-left: 15px;
            }
            .auto-list {
                 border-bottom: 0px;
             }
            .popup-alert.success {
                color: #46C37B!important;
                font-size: 12px!important;
            }
    }
        .buttons {
            margin-bottom: 20px;
            margin-top: 20px;
            &.top {
                display: none;
                text-align: left;
             }
        }
        .popup-split {
            width: 47%;
            display: inline-block;
            vertical-align: top;
            &.left {
            margin-right: 4%;
             }
        }
        .tags .icon {
            margin-top: 9px;
        }
        .domain-extension label {
            visibility: hidden;
        }
        .constrain {
            width: 100%;
        }
        .braintree-toggle {
            display: block;
            span {
                border: 2px solid #fff;
                font-weight: 600;
                font-size: 12px;
                color: #fff;
                &:hover {
                    background: #fff;
                    color: #333;
                }
            }
            &:hover {
                background: transparent;
            }
        }
        .braintree-heading {
            color: #fff;
        }
        .create-invoice {
            text-align: center;
            padding: 20px 0px;
            .instruct-sm {
                top: 17px;
                text-align: center;
            }
        }
        .popup-alert {
            padding: 3px 0px;
            font-size: 12px;
        &.error {
             color: #FD4F58!important;
         }
        &.success {
             color: #46C37B;
         }
        i {
            float: none;
            position: relative;
            top: 2px;
            right: 0px;
            opacity: 1;
        }
        }
        /* Dropdowns too low */
        .auto-list ul {
            border-radius: 0px;
            margin-top: -40px;
            box-shadow: none;
            li {
                font-size: 13px;
                border-color: #e5e5e5;
            }
        }
        .split-fields .form-group:first-child {
            @media (max-width: 500px) {
                margin-right: 0px;
            }
        }
        .split-fields .form-group {
            @media (max-width: 500px) {
                width: 100%;
                display: block;
            }
        }
    }
    .legend {
        padding: 15px;
        border: 1px solid #e6e6e6;
        background: #fff;
        font-size: 11px;
        line-height: 170%;
        margin-top: 20px;
        text-align: left;
        color: #555;
    }
    .vdp-datepicker__calendar {
        background: #363944 !important;
        border-color: #363944!important;
        .cell:not(.blank):not(.disabled).day:hover {
            border-color: #36aee5!important;
        }
        .cell.selected {
            background: #36aee5!important;
        }
        span {
            color: #fff!important;
            &.today {
                background: #474c5a;
            }
        }
        header {
            .next {
                &:after {
                     border-left: 10px solid #474c5a !important;
                    &:hover {
                         border-color: #fff!important;
                     }
                }
                 &:not(.disabled):hover {
                    background: #30313b!important;

                  }
            }
            .prev {
                &:after {
                     border-right: 10px solid #474c5a !important;
                 }
                &:not(.disabled):hover {
                     background: #30313b !important;
                 }
            }
            span {
                &:hover {
                    background: #30313b !important;
                }
            }
        }


    }
</style>
